var moment = require('moment');

export default function($mdDateLocaleProvider){
    $mdDateLocaleProvider.formatDate = function (date) {
        return moment(date).format('DD/MM/YYYY');
    };
}


/** WEBPACK FOOTER **
 ** ./js/config/datepiker.js
 **/